<template>
  <v-container>
    <v-row>
      <v-row>
        <v-col cols="12" class="headline">
          {{ selectedOracle.title }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="body-2">
          <div v-html="selectedOracle.descriptionHtml"></div>
        </v-col>
      </v-row>

    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'OracleDisplay',
    props: ['oracleID'],
    computed: {
      ...mapGetters('oracle', ['oracleByID', 'allOracles']),
    },
    watch: {
      oracleID(id) {
        const oracle = this.oracleByID(id);
        this.selectedOracle = oracle;
      },
    },
    created() {
      const oracle = this.oracleByID(this.oracleID);
      this.selectedOracle = oracle;
    },
    data() {
      return {
        selectedOracle: {},
      };
    },
  };
</script>
